/** Solar elevation in degrees. Positive means the sun is above the horizon. */
export function sunElevationDeg(at: Date, latDeg: number, lonDeg: number): number {
  const ms = at.getTime();
  if (!Number.isFinite(ms) || !Number.isFinite(latDeg) || !Number.isFinite(lonDeg)) return Number.NaN;
  const jd = ms / 86_400_000 + 2_440_587.5;
  const d = jd - 2_451_545.0;
  const rad = Math.PI / 180;
  const g = (357.529 + 0.98560028 * d) * rad;
  const q = 280.459 + 0.98564736 * d;
  const L = ((q + 1.915 * Math.sin(g) + 0.02 * Math.sin(2 * g)) % 360) * rad;
  const e = (23.439 - 0.00000036 * d) * rad;
  const ra = Math.atan2(Math.cos(e) * Math.sin(L), Math.cos(L));
  const dec = Math.asin(Math.sin(e) * Math.sin(L));
  const gmstHours = (18.697374558 + 24.06570982441908 * d) % 24;
  const gmst = (gmstHours < 0 ? gmstHours + 24 : gmstHours) * 15 * rad;
  const ha = gmst + lonDeg * rad - ra;
  const lat = latDeg * rad;
  const sinAlt = Math.sin(lat) * Math.sin(dec) + Math.cos(lat) * Math.cos(dec) * Math.cos(ha);
  return (Math.asin(Math.max(-1, Math.min(1, sinAlt))) * 180) / Math.PI;
}

/** One landing. Day when the sun is up at touchdown, otherwise night. */
export function landingSplit(
  touchdownUtc: string | undefined,
  lat: number | undefined,
  lon: number | undefined,
): { landingsDay: number; landingsNight: number } {
  if (!touchdownUtc) return { landingsDay: 0, landingsNight: 0 };
  const at = new Date(touchdownUtc);
  if (!Number.isFinite(at.getTime()) || lat == null || lon == null) return { landingsDay: 1, landingsNight: 0 };
  return sunElevationDeg(at, lat, lon) > 0
    ? { landingsDay: 1, landingsNight: 0 }
    : { landingsDay: 0, landingsNight: 1 };
}
